import React from "react";
import Slider from "react-slick";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../styles/desktop/pages/index.css"

const ImageSlider = ({ 
  images, 
  titles = [], 
  subtitles = [], 
  settings: customSettings, 
  imgSx, 
  noPaddingRight 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!images || images.length === 0) return null;

  // Ensure we have titles and subtitles for all images
  const slideData = images.map((img, index) => ({
    image: img,
    title: titles[index] || "",
    subtitle: subtitles[index] || ""
  }));

  const defaultSettings = {
    dots: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 500,
    arrows: false,
    slidesToShow: isMobile ? 1 : 1,
    slidesToScroll: 1,
    centerMode: isMobile ? true : false,
    centerPadding: isMobile ? "20px" : "0px",
    appendDots: (dots) => (
      <Box
        sx={{
          mt: isMobile ? "10px" : 0,
          position: isMobile ? "static" : "absolute",
          bottom: isMobile ? "auto" : "14px",
          left: isMobile ? "auto" : "50%",
          transform: isMobile ? "none" : "translateX(-50%)",
          display: "flex",
          justifyContent: "center",
          zIndex: 2,
          background: isMobile ? "transparent" : "rgba(255, 255, 255, 0.10)",
          backdropFilter: isMobile ? "none" : "blur(50px)",
          padding: isMobile ? 0 : "4px 8px",
          borderRadius: isMobile ? 0 : "20px",
          width: "fit-content",
          margin: isMobile ? "8px auto 0 auto" :"auto",
          "& ul": {
            margin: 0,
            padding: 0,
            display: "flex",
            gap: "4px",
          },
          "& li": {
            width: "auto !important",
            height: "auto !important",
            margin: "0 4px",
          },
        }}
      >
        {dots}
      </Box>
    ),
    customPaging: (i) => (
      <Box
        sx={{
          width: isMobile ? "4px" : "6px",
          height: isMobile ? "4px" : "6px",
          borderRadius: "50%",
          backgroundColor: "#D9D9D9",
        }}
      />
    ),
  };

  const sliderSettings = { ...defaultSettings, ...customSettings };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        ".slick-dots li.slick-active div": {
          backgroundColor: "#A9C74E",
          width: "6px",
          height: "6px",
        },
      }}
    >
      <Slider {...sliderSettings} sx={{ height: "100%" }}>
        {slideData.map((slide, index) => (
          <Box
            key={index}
            sx={{
               height: "100%",
              position: "relative",
            }}
          >
            <Box
              component="img"
              src={slide.image}
              alt={`slide-${index}`}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "8px",
                ...imgSx,
              }}
            />
            {(slide.title || slide.subtitle) && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 61.26%, rgba(0, 0, 0, 0.50) 81.89%)",
                  color: "white",
                  padding: "20px",
                  borderBottomLeftRadius: "16px",
                  borderBottomRightRadius: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  justifyContent: "end",
                  paddingBottom: "37px",
                  height: "100%",
                }}
              >
                {slide.title && (
                  <Typography
                    variant="h5"
                    component="h3"
                    className="left-title"
                    sx={{
                      fontWeight: "700",
                      fontSize: isMobile ? "23px" : "32px",
                      color: "#FFF",
                    }}
                  >
                    {slide.title}
                  </Typography>
                )}
                {slide.subtitle && (
                  <Typography
                    variant="body1"
                    className="left-sub-title"
                    sx={{
                      fontWeight: "400",
                      fontSize: isMobile ? "10px" : "14px",
                      color: "#FFF",
                    }}
                  >
                    {slide.subtitle}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default ImageSlider;